import { type AdvanceFilter } from '@/_containers';

import { CustomSupportFilterWithRadios } from './custom-support-filter-with-radios';

import type { SupportFilterSchema } from '../../shared/filters';

export function filterRenderer(
  f: AdvanceFilter<SupportFilterSchema>,
  handleSubmitAdvFilters: (v: AdvanceFilter<SupportFilterSchema>) => void
) {
  return <CustomSupportFilterWithRadios {...f} handleSubmitAdvFilters={handleSubmitAdvFilters} />;
}
